import React from 'react';
import type { CustomGlyphProps } from '@atlaskit/icon/types';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const TaskIcon = (props: CustomGlyphProps) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1839_54402)">
			<path
				d="M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z"
				fill={token('color.icon.subtle', colors.N700)}
				fill-opacity="0.31"
				data-testid={props['data-testid']}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6905 4.61002C13.09 4.99136 13.1047 5.62435 12.7234 6.02385L7.87357 11.1046C7.34831 11.6549 6.46987 11.6548 5.94462 11.1046L3.27665 8.30957C2.89531 7.91007 2.91003 7.27707 3.30953 6.89573C3.70902 6.5144 4.34202 6.52912 4.72336 6.92861L6.90909 9.21843L11.2766 4.6429C11.658 4.2434 12.291 4.22868 12.6905 4.61002Z"
				fill={token('color.icon.inverse', 'white')}
			/>
		</g>
	</svg>
);

export default TaskIcon;
